import type { FC, ReactNode } from 'react';

interface PageContainerProps {
  children: ReactNode;
}

export const PageContainer: FC<PageContainerProps> = ({ children }) => (
  <div className='flex h-screen items-center justify-center'>{children}</div>
);
